import { render } from "./QuizForm.vue?vue&type=template&id=45060a61"
import script from "./QuizForm.vue?vue&type=script&lang=js"
export * from "./QuizForm.vue?vue&type=script&lang=js"

import "./QuizForm.vue?vue&type=style&index=0&id=45060a61&lang=css"
import "./QuizForm.vue?vue&type=style&index=1&id=45060a61&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__